export default __webpack_public_path__ + "static/media/Coverings of the Revelations.1c78b785.jpg";